import { render, staticRenderFns } from "./wx-audio.vue?vue&type=template&id=56b5bc97&scoped=true&"
import script from "./wx-audio.vue?vue&type=script&lang=js&"
export * from "./wx-audio.vue?vue&type=script&lang=js&"
import style0 from "./wx-audio.vue?vue&type=style&index=0&id=56b5bc97&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b5bc97",
  null
  
)

export default component.exports